export default {
	"dashboard.top.card1.title": "Rules live",
	"dashboard.top.card2.title": "Automated rules help you save",
	"dashboard.top.card2.tips": "This data(counted from the last 30 days) is calculated by machine learning algorithms learned from big data, which is for reference only.",
	"dashboard.top.card3.title": "Automated rules help you increase",
	"dashboard.top.card3.units": "impressions",

	"dashboard.bottom.card1.top.title": "Joined teams",
	"dashboard.bottom.card2.title": "Team members",
	"dashboard.bottom.card2.button": "Invite members",
	"dashboard.bottom.card3.title": "Upgrade",
	"dashboard.bottom.card3.subtitle": "You'll get more benefits",
	"dashboard.bottom.card3.bottom.button": "Upgrade Now",
}
